// @ngInject
function ProductsApiService($q, $rootScope, DS, DSHttpAdapter, ResourcesService, $cookies, $window) {

    var endpoint = 'products';

    return {
        createProduct: ResourcesService.apiFactory.create(endpoint, 'Product'),
        downloadArticleLabels: downloadArticleLabels,
        downloadArticleVariantLabels: downloadArticleVariantLabels,
        getArticleCollections: ResourcesService.apiFactory.get(endpoint + '/articlecollections'),
        getArticleTypes: ResourcesService.apiFactory.get(endpoint + '/articletypes'),
        getCountries: ResourcesService.apiFactory.get(endpoint + '/countries'),
        getCurrencies: ResourcesService.apiFactory.get(endpoint + '/currencies'),
        getDefaultCurrency: ResourcesService.apiFactory.get(endpoint + '/tenantdefault'),
        getIntrastats: ResourcesService.apiFactory.get(endpoint + '/intrastats'),
        getItemGroup: ResourcesService.apiFactory.get(endpoint + '/itemgroup'),
        getItemGroups: ResourcesService.apiFactory.get(endpoint + '/itemgroups'),
        getItemGroupBriefs: ResourcesService.apiFactory.get(endpoint + '/itemgroupbriefs'),
        getItemGroupFlats: ResourcesService.apiFactory.get(endpoint + '/itemgroupflats'),
        getLocations: ResourcesService.apiFactory.get(endpoint + '/locations'),
        getMainGroup: ResourcesService.apiFactory.get(endpoint + '/maingroup'),
        getOrderCollections: ResourcesService.apiFactory.get(endpoint + '/ordercollections'),
        getProduct: ResourcesService.apiFactory.get(endpoint),
        getProducts: getProducts,
        getProductIds: getProductIds,
        getProductPrices: getProductPrices,
        //getProductStocks: getProductStocks,
        getProductStocks: ResourcesService.apiFactory.get('stock/productstock/'),
        getProductStockLocations: getProductStockLocations,
        getProductVariants: getProductVariants,
        getProductVariantsInTransitValues: getProductVariantsInTransitValues,
        getProductVariantsStocks: getProductVariantsStocks,
        getProductClasses: ResourcesService.apiFactory.get(endpoint + '/articleclasses'),
        getRights: ResourcesService.apiFactory.get('/rights'),
        getSalesChannels: ResourcesService.apiFactory.get(endpoint + '/saleschannels'),
        getSuppliers: getSuppliers,
        getVariant: ResourcesService.apiFactory.get(endpoint + '/variant'),
        // getMultipliers: ResourcesService.apiFactory.get(endpoint + '/multipliers'),
        getMultipliers: getMultipliers,
        ReadMultipliersToEdit: ReadMultipliersToEdit,
        updateMonthMultiplier: updateMonthMultiplier,
        createMonthMultiplier: createMonthMultiplier,
        deleteMonthMultiplier: deleteMonthMultiplier,
        changeMultiplierOnArticle, changeMultiplierOnArticle,
        saveNewIntrastat: saveNewIntrastat,
        updateProduct: updateProduct,
        getAllArticleVariants: getAllArticleVariants,
        changeItemGroup: ResourcesService.apiFactory.update(endpoint + '/changeItemGroup'),
        getArticleChangeVariantDetailObject: getArticleChangeVariantDetailObject,
        getVariantDetailOptions: getVariantDetailOptions,
        getVariantDetailOptionsPaged: getVariantDetailOptionsPaged,
        changeArticleVariantDetail: ResourcesService.apiFactory.update(endpoint + '/changeArticleVariantDetail'),
        hasSimpleWms: hasSimpleWms,
        checkIfBarcodeExists: checkIfBarcodeExists,
        getMetaFieldValues: getMetaFieldValues,
        getMetaFields: getMetaFields,
        upsertMetaFields: upsertMetaFields,
        upsertMetaFieldValues: upsertMetaFieldValues
    };

    function getProducts(request) {

        var params = {
            filter: '',
            page: 1,
            pageSize: 20
        };

        //page, filter, pageSize, companyId, showInactiveArticles
        if (request.currentPage && request.currentPage > 1) {
            params.page = request.currentPage;
        }

        if (request.pageSize && request.pageSize > 0) {
            params.pageSize = request.pageSize;
        }

        if (!_.isEmpty(request.filter)) {
            params.filter = request.filter;
        }

        if (request.companyId) {
            params.companyId = request.companyId;
        }

        if (request.showInactiveArticles) {
            params.showInactiveArticles = request.showInactiveArticles;
        }

        if (request.matchEntireSearchTerm !== undefined) {
            params.matchEntireSearchTerm = request.matchEntireSearchTerm;
        }

        var args = {params: params};

        return ResourcesService.apiFactory.get(endpoint)(args);
    }

    function getMetaFieldValues(articleId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.rms2Path + 'metafieldvalue/' + articleId).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getMetaFields() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.rms2Path + 'metafield/').then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function upsertMetaFields(metaFieldsData) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.rms2Path + 'metafield/', metaFieldsData)
            .then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(handleError(error));
            });

        return deferred.promise;
    }

    function upsertMetaFieldValues(articleId, values) {
        var deferred = $q.defer();

        var data = {
            articleId: articleId,
            metaFieldValues: values
        }

        DSHttpAdapter.POST(DS.defaults.rms2Path + 'metafieldvalue/', data)
            .then(function (response) {
                deferred.resolve(response.data);
            }, function (error) {
                deferred.reject(handleError(error));
            });

        return deferred.promise;
    }

    function getSuppliers(brandId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'products/suppliers/brand/' + brandId).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getProductIds(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + '/products/ids', request).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getProductPrices(articleId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/' + articleId + '/prices').then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getProductVariants(page, filter, pageSize, collectionId, onlyWithNegativeEshopStock) {
        var deferred = $q.defer();
        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(filter)) {
            params.searchTerm = filter;
        }

        if (collectionId > 0) {
            params.collectionId = collectionId;
        }

        if (onlyWithNegativeEshopStock) {
            params.onlyWithNegativeEshopStock = onlyWithNegativeEshopStock;
        }

        DSHttpAdapter.GET(DS.defaults.basePath + 'articleVariants', {params: params}).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }

    function getProductVariantsStocks(articleVariantsAndLocationIds) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'articlevariants/stocks', articleVariantsAndLocationIds).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getProductVariantsInTransitValues(articleVariantsAndLocationIds) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'articlevariants/intransit', articleVariantsAndLocationIds).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function downloadArticleLabels(productId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'products/' + productId + '/labels', {responseType: 'arraybuffer'}).then(function (response) {
            var blob = new Blob([response.data], {type: 'application/pdf'});
            var contentDisposition = response.headers('Content-Disposition');
            var fileName = getFileName(contentDisposition, 'labels.pdf');

            if ($window.navigator.msSaveBlob) {
                $window.navigator.msSaveBlob(blob, fileName);
            } else {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);

                a.parentNode.removeChild(a);
            }

            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getFileName(contentDisposition, defaultValue) {
        //"attachment; filename=PickingList36013.pdf"
        var filename = defaultValue;
        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            var filenameRegex = /(?![=]{1})([\w\d\s]){1,}.pdf/ig;
            var matches = new RegExp(filenameRegex).exec(contentDisposition);
            if (matches != null && matches[0]) {
                filename = matches[0];
            }
        }
        return filename;
    }

    function downloadArticleVariantLabels(labelRequests) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'products/labels', labelRequests).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function saveNewIntrastat(articleId, articleVariantId, intrastat) {
        var params = {
            articleId: articleId,
            articleVariantId: articleVariantId,
            intrastat: intrastat
        };

        return ResourcesService.apiFactory.save('/products/intrastat', 'Intrastat')(params);
    }

    function updateProduct(id, data) {

        // The internal json stringification of DSHttpAdapter seems to cause some object fields to go
        // missing for some reason.
        data = JSON.stringify(data);

        return ResourcesService.apiFactory.update(endpoint + '/' + id, 'Product')(data);
    }

    function getAllArticleVariants(page, filter, pageSize, collectionId, onlyWithNegativeEshopStock) {
        var deferred = $q.defer();
        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(filter)) {
            params.searchTerm = filter;
        }

        if (collectionId > 0) {
            params.collectionId = collectionId;
        }

        if (onlyWithNegativeEshopStock) {
            params.onlyWithNegativeEshopStock = onlyWithNegativeEshopStock;
        }

        DSHttpAdapter.GET(DS.defaults.basePath + 'articleVariants', {params: params}).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }

    function hasSimpleWms() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/hasSimpleWms').then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }

    function getProductStockLocations(warehouseId, productId) {

        console.log('warehouseId: ' + warehouseId + ', productId: ' + productId);
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/stocklocations/warehouses/' + warehouseId + '/products/' + productId).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
        /*
                console.log('warehouseId: ' + warehouseId + ', productId: ' + productId);
                return ResourcesService.apiFactory.get(endpoint + '/stocklocations/warehouses/' + warehouseId + '/products/' + productId);
                */
    }

    function getArticleChangeVariantDetailObject(articleId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/getchangevariantdetailobject/' + articleId).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getVariantDetailOptionsPaged(request) {

        var params = {
            filter: '',
            page: 1,
            pageSize: 20,
            variantDetailType: 1
        };

        //page, filter, pageSize, companyId, showInactiveArticles
        if (request.currentPage && request.currentPage > 1) {
            params.page = request.currentPage;
        }

        if (request.pageSize && request.pageSize > 0) {
            params.pageSize = request.pageSize;
        }

        if (!_.isEmpty(request.filter)) {
            params.filter = request.filter;
        }

        if (request.variantDetailType) {
            params.variantDetailType = request.variantDetailType;
        }

        var args = {params: params};

        return ResourcesService.apiFactory.get(endpoint + '/getvariantdetailoptionspaged')(args);
    }

    function getVariantDetailOptions(variantDetailType) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/getvariantdetailoptions/' + variantDetailType).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function deleteMonthMultiplier(requestId) {
        var deferred = $q.defer();

        DSHttpAdapter.DEL(DS.defaults.basePath + 'products/multiplier/' + requestId).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function changeMultiplierOnArticle(articleId, stockLogisticsMonthMultipliersDto) {
        var deferred = $q.defer();
        var jsonRequest = JSON.stringify(stockLogisticsMonthMultipliersDto);
        DSHttpAdapter.PUT(DS.defaults.basePath + 'products/multiplier/' + articleId, jsonRequest).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function createMonthMultiplier(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'products/multiplier/', request).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function updateMonthMultiplier(request) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + 'products/multiplier/', request).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getMultipliers(articleId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'products/multiplier/' + articleId).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function ReadMultipliersToEdit(articleId) {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'products/multiplier/edit/' + articleId).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function checkIfBarcodeExists(barcode) {
        var deferred = $q.defer();
        var params = {};

        if (_.isUndefined(barcode) || barcode === "") {
            return false;
        }

        params.barcode = barcode;

        DSHttpAdapter.GET(DS.defaults.basePath + 'articlevariants/barcodeexists', {params: params}).then(function (response) {
            deferred.resolve(response.data);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

}

angular.module('products.api', [])
  .factory('ProductsApiService', ProductsApiService);
